import i18n from '@/locales'
import store from '@/store'
import Layout from '@/layouts/RouterView'
import { featureMenuHiddenCheck } from '@/utils/auth'
import { isScopedPolicyMenuHidden } from '@/utils/scopedPolicy'

const ModelArts = () => import(/* webpackChunkName: "ai" */ /* webpackPrefetch: true */ '@Ai-ee/views/modelarts')
const ModelArtsCreate = () => import(/* webpackChunkName: "ai" */ /* webpackPrefetch: true */ '@Ai-ee/views/modelarts/create')

export default {
  index: 61,
  meta: {
    label: i18n.t('ai'),
    icon: 'menu-ai',
    hidden: () => {
      return store.getters.isSysCE
    },
  },
  menus: [
    {
      meta: {
        label: i18n.t('ai'),
      },
      submenus: [
        {
          path: '/modelarts',
          permission: 'modelarts_list',
          meta: {
            label: 'ModelArts',
            hidden: (userInfo, menu) => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.modelarts')) {
                return true
              }
              return featureMenuHiddenCheck(menu)
            },
          },
          component: Layout,
          children: [
            {
              name: 'ModelArts',
              path: '',
              component: ModelArts,
            },
            {
              name: 'ModelArtsCreate',
              path: 'create',
              component: ModelArtsCreate,
            },
          ],
        },
      ],
    },
  ],
}
